<template>
    <section class="internet-explorer-warning">
        <div class="box">
            <div class="informative-text">
                <b>{{ 'internet-explorer.no-supported' | lang }}</b>

                <span>{{ 'internet-explorer.info' | lang }}</span>

                <b>{{ 'internet-explorer.use-supported-browsers' | lang }}</b>
            </div>

            <div class="browser-options">
                <a v-for="option in browsers" :href="option.href" target="_blank" class="option">
                    <img :src="`/material/img/browsers/${option.code}.png`" :alt="option.name" :class="['browser-image', option.code]" />
                    <div class="browser">{{ option.name }}</div>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "InternetExplorerWarning",
        data() {
            return {
                browsers: [{
                    name: 'Google Chrome',
                    code: 'chrome',
                    href: 'https://www.google.com/chrome/'
                }, {
                    name: 'Mozilla Firefox',
                    code: 'firefox',
                    href: 'https://www.mozilla.org/en-US/firefox/new/'
                }, {
                    name: 'Microsoft Edge',
                    code: 'edge',
                    href: 'https://www.microsoft.com/en-us/edge'
                }]
            }
        },
    }
</script>

<style scoped lang="scss">
    $text-color: #A26922;

    .internet-explorer-warning {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .box {
            width: 500px;
            padding: 40px;

            color: $text-color;
            border-radius: 3px;
            background: #FEDAA4;
        }

        .informative-text {
            text-align: center;

            & > span {
                display: block;
                padding: 20px 0;
            }
        }

        .browser-options {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            padding-top: 20px;
        }

        .option {
            flex: 0 1 42%;
            margin: 0 8px 8px 0;

            display: flex;
            align-items: center;
            padding: 12px;

            color: $text-color;
            border: 1px solid #EBB97A;
            border-radius: 3px;
            cursor: pointer;

            &:hover {
                background: rgba($text-color, .25)
            }

            &:nth-of-type(2) {
                margin-right: 0;
            }

            &:nth-of-type(3) {
                margin: 0;
            }
        }

        .browser {
            margin-left: 8px;

            &-image {
                width: 24px;
            }
        }
    }
</style>